import React from "react"
import { ConnectedUserNdfDepenseCreateSimple } from "./simple/ConnectedUserNdfDepenseCreateSimple"
import { useConnectedUserNdfDepensesContext } from "../_PersonnelNdfDepenses"
import ConnectedUserNdfDepenseCreateGrouped from "./grouped/ConnectedUserNdfDepenseCreateGrouped"

const ConnectedUserNdfDepenseCreateForm = () => {
     const context = useConnectedUserNdfDepensesContext()

     // --- VUE 1 : SÉLECTION DU TYPE DE DÉPENSE (Style Step1Selection) ---
     if (context.typeAddDepense === null) {
          return (
               <div className="animate__animated animate__fadeIn">
                    <div className="text-center mb-10">
                         <h2 className="fw-boldest text-gray-900 mb-2">Que souhaitez-vous ajouter ?</h2>
                         <p className="text-muted fw-semibold fs-5">Choisissez le type de saisie qui correspond à votre note de frais.</p>
                    </div>

                    <div className="row g-6">
                         {/* Option Dépense Simple */}
                         <div className="col-md-6">
                              <div
                                   className="card border border-1 border-dashed border-primary bg-hover-light-primary cursor-pointer transition-all h-100"
                                   onClick={() => context.setTypeAddDepense("simple")}
                              >
                                   <div className="card-body d-flex flex-column align-items-center text-center p-10">
                                        <div className="symbol symbol-70px mb-5">
                                             <div className="symbol-label bg-light-primary">
                                                  <i className="fas fa-file-invoice-dollar fs-2x text-primary"></i>
                                             </div>
                                        </div>
                                        <h3 className="fw-boldest mb-2">Dépense Simple</h3>
                                        <p className="text-gray-600 fs-6">
                                             Saisie rapide pour un <strong>seul justificatif</strong> ou une facture ponctuelle.
                                        </p>
                                        <span className="badge badge-light-primary fw-bold">Un seul justificatif</span>
                                   </div>
                              </div>
                         </div>

                         {/* Option Saisie Groupée */}
                         <div className="col-md-6">
                              <div
                                   className="card border border-1 border-dashed border-info bg-hover-light-info cursor-pointer transition-all h-100"
                                   onClick={() => context.setTypeAddDepense("group")}
                              >
                                   <div className="card-body d-flex flex-column align-items-center text-center p-10">
                                        <div className="symbol symbol-70px mb-5">
                                             <div className="symbol-label bg-light-info">
                                                  <i className="fas fa-layer-group fs-2x text-info"></i>
                                             </div>
                                        </div>
                                        <h3 className="fw-boldest mb-2">Saisie Groupée</h3>
                                        <p className="text-gray-600 fs-6">
                                             Agrégez <strong>plusieurs lignes</strong> de frais sous une seul et même note.
                                        </p>
                                        <span className="badge badge-light-info fw-bold">Multiples lignes</span>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          )
     }

     // --- VUE 2 : LE FORMULAIRE SÉLECTIONNÉ ---
     return (
          <div className="animate__animated animate__fadeIn">
               <div className="d-flex align-items-center mb-5 gap-3">
                    <button className="btn btn-sm btn-icon btn-light" onClick={() => context.setTypeAddDepense(null)}>
                         <i className="bi bi-arrow-left fs-3"></i>
                    </button>
                    <h3 className="fw-boldest mb-0">{context.typeAddDepense === "simple" ? "Dépense Simple" : "Dépenses Groupées"}</h3>
               </div>
               {context.typeAddDepense === "simple" ? <ConnectedUserNdfDepenseCreateSimple /> : <ConnectedUserNdfDepenseCreateGrouped />}
          </div>
     )
}

export default ConnectedUserNdfDepenseCreateForm
